module.exports = __webpack_public_path__ + "static/media/boiling-banner.7de1dec7.webp";